import { fieldNames } from '../fields';

const dataModel = {
    id: String(),
    component: String(),
};

const defaults = {
    component: fieldNames.pageBreak
};

export const pageBreakData = { dataModel, defaults };